// extracted by mini-css-extract-plugin
module.exports = {"initialValues":"DefaultValue__initialValues--2AVjl"};